import { IContributionsLimitsState } from './state';
import { createReducer, on, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction, createFormControlState, createFormGroupState, setValue
} from 'ngrx-forms';
import { ResetFormAction, ResponseAction } from './actions';
import { ContributionDetailModel } from '../../../../model/contributions-limit.model';

export const contributionsState: IContributionsLimitsState = {
  data: new ContributionDetailModel()
};

const reducer = createReducer(contributionsState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {
    return {
      ...state,
      data: payload
    }
  }), on(ResetFormAction, (state) => {
    return {
      data: new ContributionDetailModel()
    }
  })
);

export function contributionsLimitsReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}

